import { regionControllerGetLocalitiesByRegionId } from './regionControllerGetLocalitiesByRegionId'
import { regionControllerGetLocalitiesBySlug } from './regionControllerGetLocalitiesBySlug'
import { regionControllerGetRegions } from './regionControllerGetRegions'

export const regionService = { regionControllerGetRegions, regionControllerGetLocalitiesByRegionId, regionControllerGetLocalitiesBySlug }